import { render, staticRenderFns } from "./ModalEstado.vue?vue&type=template&id=6c136423"
import script from "./ModalEstado.vue?vue&type=script&lang=js"
export * from "./ModalEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports